import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip);

const ExpenseChart = ({ expenses }) => {
  const grouped = {};
  expenses.forEach((exp) => {
    grouped[exp.date] = (grouped[exp.date] || 0) + exp.amount;
  });

  const labels = Object.keys(grouped).sort();
  const data = labels.map((date) => grouped[date]);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Expenses',
        data,
        borderColor: 'rgba(99, 102, 241, 1)',
        backgroundColor: 'rgba(99, 102, 241, 0.3)',
        tension: 0.4,
        fill: true,
      },
    ],
  };

  return (
    <div className="bg-white p-4 rounded-xl shadow-md mb-6">
      <h3 className="font-semibold text-gray-800 mb-3">Expense Trends</h3>
      <Line data={chartData} />
    </div>
  );
};

export default ExpenseChart;
